import { createSelector } from "reselect";

import { OhCase, AppState } from "./models";

export const routeIdSelector = (state: AppState) => {
    return state.router.params!.ohCaseId;
};

export type SelectorState = AppState;

export const ohCasesSelector = (state: AppState) => state.ohCases;

/* eslint-disable deprecation/deprecation */
/**
 * @deprecated Prefer `useOhCaseDetailsModel` hook
 */
export const ohCaseSelector = createSelector(
    ohCasesSelector,
    routeIdSelector,
    (ohCases: OhCase[], id: any) => {
        return ohCases.filter(c => c.id === id)[0] || {} as OhCase;
    }
);
/* eslint-enable deprecation/deprecation */

export const basePathSelector = (state: AppState) =>
    state.router.pathname!.substring(0, state.router.pathname!.indexOf("ohCases") + "ohCases".length);
